import { Switch, FormControlLabel } from '@mui/material';
import { useExpandCollapseToggle } from './useExpandCollapseToggle';
import { ExpandCollapseToggleProps } from './types';
import './ExpandCollapseToggle.scss';

export const ExpandCollapseToggle = (props: ExpandCollapseToggleProps) => {
  const { areAllExpanded, handleToggleClick } = useExpandCollapseToggle(props);

  return (
    <FormControlLabel
      className="expandCollapseToggle"
      control={
        <Switch
          checked={areAllExpanded}
          onChange={handleToggleClick}
          size="small"
        />
      }
      label="Expand All"
      labelPlacement="start"
    />
  );
};
